import { ReactComponent as Alert } from "../assets/icons/alert.svg";
import { ReactComponent as ArrowsToCircle } from "../assets/icons/arrows-to-circle.svg";
import { ReactComponent as Award } from "../assets/icons/award.svg";
import { ReactComponent as Building } from "../assets/icons/building.svg";
import { ReactComponent as Calculator } from "../assets/icons/calculator.svg";
import { ReactComponent as Calendar } from "../assets/icons/calendar.svg";
import { ReactComponent as Certificate } from "../assets/icons/certificate.svg";
import { ReactComponent as ChampagneGlasses } from "../assets/icons/champagne-glasses.svg";
import { ReactComponent as Checked } from "../assets/icons/checked.svg";
import { ReactComponent as ChevronRight } from "../assets/icons/chevron-right.svg";
import { ReactComponent as CircleCheck } from "../assets/icons/circle-check.svg";
import { ReactComponent as City } from "../assets/icons/city.svg";
import { ReactComponent as ClipboardCheck } from "../assets/icons/clipboard-check.svg";
import { ReactComponent as Clipboard } from "../assets/icons/clipboard.svg";
import { ReactComponent as Clock } from "../assets/icons/clock.svg";
import { ReactComponent as Compass } from "../assets/icons/compass.svg";
import { ReactComponent as Cube } from "../assets/icons/cube.svg";
import { ReactComponent as Drop } from "../assets/icons/drop.svg";
import { ReactComponent as DropletSlash } from "../assets/icons/droplet-slash.svg";
import { ReactComponent as Dumbbell } from "../assets/icons/dumbbell.svg";
import { ReactComponent as Envelope } from "../assets/icons/envelope.svg";
import { ReactComponent as Euro } from "../assets/icons/euro.svg";
import { ReactComponent as Eye } from "../assets/icons/eye.svg";
import { ReactComponent as Facebook } from "../assets/icons/facebook.svg";
import { ReactComponent as Filter } from "../assets/icons/filter.svg";
import { ReactComponent as Gears } from "../assets/icons/gears.svg";
import { ReactComponent as Graduation } from "../assets/icons/graduation.svg";
import { ReactComponent as GripLines } from "../assets/icons/grip-lines.svg";
import { ReactComponent as HandBack } from "../assets/icons/hand-back.svg";
import { ReactComponent as Handshake } from "../assets/icons/handshake.svg";
import { ReactComponent as Helmet } from "../assets/icons/helmet.svg";
import { ReactComponent as Hole } from "../assets/icons/hole.svg";
import { ReactComponent as House } from "../assets/icons/house.svg";
import { ReactComponent as IdCardsvg } from "../assets/icons/id-cardsvg.svg";
import { ReactComponent as Increment } from "../assets/icons/increment.svg";
import { ReactComponent as Industry } from "../assets/icons/industry.svg";
import { ReactComponent as Instagram } from "../assets/icons/instagram.svg";
import { ReactComponent as LayerGroup } from "../assets/icons/layer-group.svg";
import { ReactComponent as Lightbulb } from "../assets/icons/lightbulb.svg";
import { ReactComponent as Location } from "../assets/icons/location.svg";
import { ReactComponent as MagnifyingGlass } from "../assets/icons/magnifying-glass.svg";
import { ReactComponent as Map } from "../assets/icons/map-.svg";
import { ReactComponent as Maximize } from "../assets/icons/maximize.svg";
import { ReactComponent as Medal } from "../assets/icons/medal.svg";
import { ReactComponent as Microscope } from "../assets/icons/microscope.svg";
import { ReactComponent as Mobile } from "../assets/icons/mobile.svg";
import { ReactComponent as PeopleGroup } from "../assets/icons/people-group.svg";
import { ReactComponent as PersonCircle } from "../assets/icons/person-circle.svg";
import { ReactComponent as Phone } from "../assets/icons/phone.svg";
import { ReactComponent as Recycle } from "../assets/icons/recycle.svg";
import { ReactComponent as Road } from "../assets/icons/road.svg";
import { ReactComponent as Rocket } from "../assets/icons/rocket.svg";
import { ReactComponent as Ruler } from "../assets/icons/ruler.svg";
import { ReactComponent as Screwdriver } from "../assets/icons/screwdriver.svg";
import { ReactComponent as Shield } from "../assets/icons/shield.svg";
import { ReactComponent as Star } from "../assets/icons/star.svg";
import { ReactComponent as TruckDroplet } from "../assets/icons/truck-droplet.svg";
import { ReactComponent as User } from "../assets/icons/user.svg";
import { ReactComponent as VolumeLow } from "../assets/icons/volume-low.svg";

// costante di mapping icone
export const ICONS: Record<
  string,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  alert: Alert,
  "arrows-to-circle": ArrowsToCircle,
  award: Award,
  building: Building,
  calculator: Calculator,
  calendar: Calendar,
  certificate: Certificate,
  "champagne-glasses": ChampagneGlasses,
  checked: Checked,
  "chevron-right": ChevronRight,
  "circle-check": CircleCheck,
  city: City,
  "clipboard-check": ClipboardCheck,
  clipboard: Clipboard,
  clock: Clock,
  compass: Compass,
  cube: Cube,
  drop: Drop,
  "droplet-slash": DropletSlash,
  dumbbell: Dumbbell,
  envelope: Envelope,
  euro: Euro,
  eye: Eye,
  facebook: Facebook,
  filter: Filter,
  gears: Gears,
  graduation: Graduation,
  "grip-lines": GripLines,
  "hand-back": HandBack,
  handshake: Handshake,
  helmet: Helmet,
  hole: Hole,
  house: House,
  "id-cardsvg": IdCardsvg,
  increment: Increment,
  industry: Industry,
  instagram: Instagram,
  "layer-group": LayerGroup,
  lightbulb: Lightbulb,
  location: Location,
  "magnifying-glass": MagnifyingGlass,
  "map-": Map,
  maximize: Maximize,
  medal: Medal,
  microscope: Microscope,
  mobile: Mobile,
  "people-group": PeopleGroup,
  "person-circle": PersonCircle,
  phone: Phone,
  recycle: Recycle,
  road: Road,
  rocket: Rocket,
  ruler: Ruler,
  screwdriver: Screwdriver,
  shield: Shield,
  star: Star,
  "truck-droplet": TruckDroplet,
  user: User,
  "volume-low": VolumeLow,
} as const;
